import { Loader2 } from "lucide-react";

import {
  Flexbox,
  VerticalFlexbox,
} from "@src/shared/components/layout/Flexbox";

export function VisitGeneratingNote() {
  return (
    <Flexbox
      alignItems="center"
      justifyContent="center"
      className="mx-auto min-h-[560px] w-full max-w-[860px] bg-background"
      aria-busy="true"
      aria-live="polite"
    >
      <VerticalFlexbox alignItems="center" className="gap-3 text-center">
        <Loader2 className="size-10 animate-spin text-primary" aria-hidden />
        <VerticalFlexbox className="gap-1">
          <h1 className="text-[15px] font-semibold text-foreground">
            Generating your note
          </h1>
          <p className="max-w-[260px] text-[12px] leading-relaxed text-muted-foreground">
            Pulling the visit into a structured note with codes and evidence.
          </p>
        </VerticalFlexbox>
      </VerticalFlexbox>
    </Flexbox>
  );
}
